/**
 * O comportamento comum a todo modal do site: Esc fecha, clique no fundo
 * escuro fecha (dentro do diálogo não), e o Tab fica preso dentro dele.
 *
 * Instalado UMA vez por contêiner — o contêiner sobrevive aos redesenhos do
 * conteúdo (`innerHTML`), então os listeners não se acumulam. Quem chama diz
 * se o modal está aberto e o que é fechar; este módulo não conhece o estado
 * de ninguém, e é por isso que o lobby e a página da mesa usam o mesmo.
 *
 * Os estilos que fazem par com ele são `.modal-fundo` e `.modal`, em
 * `styles.css`.
 */
export function instalarModal(container: HTMLElement, aberto: () => boolean, fechar: () => void): void {
  container.addEventListener('keydown', (e) => {
    if (!aberto()) return
    if (e.key === 'Escape') {
      e.preventDefault()
      fechar()
      return
    }
    if (e.key !== 'Tab') return
    const focaveis = [
      ...container.querySelectorAll<HTMLElement>(
        'button:not([disabled]), input:not([disabled]), select:not([disabled]), a[href]',
      ),
    ]
    if (focaveis.length === 0) return
    const primeiro = focaveis[0]!
    const ultimo = focaveis[focaveis.length - 1]!
    const dialogo = container.querySelector('.modal')
    if (e.shiftKey && (document.activeElement === primeiro || document.activeElement === dialogo)) {
      e.preventDefault()
      ultimo.focus()
    } else if (!e.shiftKey && document.activeElement === ultimo) {
      e.preventDefault()
      primeiro.focus()
    }
  })

  container.addEventListener('click', (e) => {
    if (e.target instanceof HTMLElement && e.target.classList.contains('modal-fundo')) fechar()
  })
}
